import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Layout from "../components/Layout";

const CompanyContainer = styled.div``;

const Section = styled.section`
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
`;

const CompanyInfo = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-top: 3rem;
`;

const InfoTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  tr {
    border-bottom: 1px solid #eee;
  }

  tr:last-child {
    border-bottom: none;
  }

  th {
    width: 30%;
    padding: 1.5rem;
    text-align: left;
    font-weight: 600;
    color: #333;
    background-color: #f9f9f9;
  }

  td {
    width: 70%;
    padding: 1.5rem;
    color: #666;
  }

  @media (max-width: 768px) {
    th,
    td {
      display: block;
      width: 100%;
    }

    th {
      padding-bottom: 0.5rem;
    }

    td {
      padding-top: 0.5rem;
    }
  }
`;

const MapContainer = styled.div`
  height: 400px;
  background-color: #f5f5f5;
  margin-top: 3rem;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 1.2rem;
`;

const HistorySection = styled.div`
  margin-top: 6rem;
`;

const Timeline = styled.div`
  position: relative;
  max-width: 800px;
  margin: 3rem auto 0;

  &::after {
    content: "";
    position: absolute;
    width: 6px;
    background-color: #0090a0;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
  }

  @media (max-width: 768px) {
    &::after {
      left: 31px;
    }
  }
`;

const TimelineItem = styled.div`
  padding: 10px 40px;
  position: relative;
  width: 50%;
  box-sizing: border-box;

  &:nth-child(odd) {
    left: 0;
  }

  &:nth-child(even) {
    left: 50%;
  }

  &::after {
    content: "";
    position: absolute;
    width: 25px;
    height: 25px;
    right: -12px;
    background-color: #fff;
    border: 4px solid #0090a0;
    top: 15px;
    border-radius: 50%;
    z-index: 1;
  }

  &:nth-child(even)::after {
    left: -12px;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;

    &:nth-child(even) {
      left: 0;
    }

    &::after {
      left: 18px;
      right: auto;
    }
  }
`;

const TimelineContent = styled.div`
  padding: 20px;
  background-color: #fff;
  position: relative;
  border-radius: 6px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #0090a0;
  }

  p {
    color: #666;
    line-height: 1.6;
  }
`;

const Company = () => {
  return (
    <Layout>
      <CompanyContainer>
        <Header
          title="会社概要"
          subtitle="テクノロイグについて"
          showButton={false}
        />

        <Section>
          <SectionTitle data-aos="fade-down" data-aos-duration="500">
            企業情報
          </SectionTitle>
          <CompanyInfo data-aos="fade-up" data-aos-duration="500">
            <InfoTable>
              <tbody>
                <tr>
                  <th>会社名</th>
                  <td>テクノロイグ株式会社</td>
                </tr>
                <tr>
                  <th>設立</th>
                  <td>2023年8月</td>
                </tr>
                <tr>
                  <th>代表取締役</th>
                  <td>安藤 駿介</td>
                </tr>
                <tr>
                  <th>従業員数</th>
                  <td>5名（2026年4月現在 業務委託含む）</td>
                </tr>
                <tr>
                  <th>事業内容</th>
                  <td>
                    SES（システムエンジニアリングサービス）
                    <br />
                    受託開発
                    <br />
                    IT教育
                    <br />
                    農業
                  </td>
                </tr>
                <tr>
                  <th>所在地</th>
                  <td>〒300-1266 茨城県つくば市自由ケ丘451番地21</td>
                </tr>
                <tr>
                  <th>お問い合わせメールアドレス</th>
                  <td>info@technoroaig.com</td>
                </tr>
              </tbody>
            </InfoTable>
          </CompanyInfo>
        </Section>
      </CompanyContainer>
    </Layout>
  );
};

export default Company;
